import React from 'react';

import scss from './TablePopper.module.scss';

const TableDropdownList = ({ content }) => {
  return (
    <ul className={scss.listWrapper}>
      {content.map((el, index) => (
        <li key={index} className={scss.listItem}>
          {el}
        </li>
      ))}
    </ul>
  );
};

export default TableDropdownList;
